<template>
  <div>
    <v-sheet
      elevation="12"
      max-width="600"
      rounded="lg"
      width="100%"
      class="pa-4 text-center mx-auto"
      color=""
    >
      <!-- <v-img src="@/assets/images/imagen0.jpg" alt="Imagen" class="img"></v-img> -->
      <h1 class="text-medium-emphasis mb-6">MATERIAL BÉLICO</h1>

      <h3 class="mb-2 text-medium-emphasis text-body-5">
        Registro de Arma por Unidad
      </h3>

      <v-divider class="mb-4"></v-divider>
    </v-sheet>
    <div><br /></div>
    <div class="container">
      <v-form v-model="valid" @submit.prevent="submit">
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="id_arma"
                :counter="10"
                :error-messages="id_arma"
                label="Id Arma"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="codigo_arma"
                :counter="7"
                :error-messages="codigo_arma"
                label="Codigo Arma"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="4"
              ><v-select
                v-model="selectedTipoArma"
                :items="tipoarmas"
                label="Tipo de Arma"
                item-text="item.descripcion"
                item-value="item.descripcion"
              >
              </v-select
            ></v-col>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="marca_arma"
                :error-messages="marca_arma"
                label="Marca"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="modelo_arma"
                :error-messages="modelo_arma"
                label="Modelo"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="4"
              ><select
              v-model="selectedCalibres"
            class="form-select"
            id="selectOption"
            aria-label="Default select example"
          >
            <!-- <option selected>Calibre</option> -->
            <option
              v-for="item in optionscalibre"
              :key="item.codigo_calibre"
              :value="item.codigo_calibre"
            >
              {{ item.codigo_calibre }} - {{ item.descripcion }}
            </option>
          </select></v-col
            >
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="cantidad_cargadores"
                :error-messages="cantidad_cargadores"
                label="Cantidad Cargadores"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="4"
              ><v-select
                v-model="selectedProcedencia"
                :items="procedencias"
                label="Pais de Procedencia"
                item-text="item.descripcion"
                item-value="item.descripcion"
              >
              </v-select
            ></v-col>
            <v-col cols="12" md="4"
              ><v-select
                v-model="selectedClasificacionarma"
                :items="clasificacionarmas"
                label="Clasificacion de Arma"
                item-text="item.descripcion"
                item-value="item.descripcion"
              >
              </v-select
            ></v-col>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="observaciones"
                :error-messages="observaciones"
                label="Observaciones"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-checkbox
            v-model="status"
            :error-messages="status"
            value="1"
            label="Estado"
            type="checkbox"
          ></v-checkbox>
          <v-btn class="me-4" @click="GuardarDatos" color="green">
            Guardar
          </v-btn>

          <v-btn @click="handleReset" color="red"> Limpiar </v-btn>
        </v-container>
      </v-form>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import Selects from "@/services/Selects";
import Armas from "@/services/Armas";
export default defineComponent({
  data() {
    var selectedCalibres = null;
    var selectedTipoArma = [];
    var selectedProcedencia = [];
    var selectedClasificacionarma = [];

    return {
      optionscalibre: [],
      id_arma: "",
      codigo_arma: "",
      marca_arma: "",
      modelo_arma: "",
      observaciones: "",
      cantidad_cargadores: "",
      status: false,
      valid: false, // Esto es necesario para v-form

      selectedCalibres,
      selectedTipoArma,
      selectedProcedencia,
      selectedClasificacionarma,
      calibres: [],
      tipoarmas: [],
      procedencias: [],
      clasificacionarmas: [],
    };
  },
  async mounted() {
    const selectcalibre = new Selects();  //--2
    const datacalibre = await selectcalibre.loadDataCalibres2();  //--2
    this.optionscalibre = datacalibre;   //--2
    console.log("Datos cargados:", datacalibre);  //--2
  },
  methods: {
    handleReset() {
      // Restablece los campos del formulario
      this.id_arma = "";
      this.codigo_arma = "";
      this.marca_arma = "";
      this.modelo_arma = "";
      this.observaciones = "";
      this.cantidad_cargadores = "";
      this.status = false;
      this.selectedTipoArma = [];
      this.selectedCalibres = [];
      this.selectedProcedencia = [];
      this.selectedClasificacionarma = [];
    },
    async GuardarDatos() {
      const formData = {
        id_arma: this.id_arma,
        codigo_arma: this.codigo_arma,
        marca_arma: this.marca_arma,
        modelo_arma: this.modelo_arma,
        observaciones: this.observaciones,
        cantidad_cargadores: this.cantidad_cargadores,
        status: this.status,
        selectedTipoArma: this.selectedTipoArma,
        codigo_calibre: this.selectedCalibres,
        selectedProcedencia: this.selectedProcedencia,
        selectedClasificacionarma: this.selectedClasificacionarma,
      };

      try {
        const registroarmas = new Armas();
        const response = await registroarmas.saveData(formData);
        this.handleReset();
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    selectedCalibres: function (newValue) {
      if (newValue) {
        console.log("Seleccionaste el calibre:", newValue);
      }
    },
  },
  async created() {
    const selectService = new Selects();
    const selectServiceTipoArma = new Selects();
    const selectServiceProcedencia = new Selects();
    const selectServiceClasificacionarma = new Selects();

    const data = await selectService.loadDataCalibres();
    const dataTipArm = await selectServiceTipoArma.loadDataTipoArma();
    const dataProcedencia =
      await selectServiceProcedencia.loadDataProcedencia();
    const dataClasificacionarma =
      await selectServiceClasificacionarma.loadDataClasificacionarma();

    if (Array.isArray(data)) {
      //console.log("Codigo-calibre", data);
      this.calibres = data;
      //console.log("Codigo-calibre", data);
    } else {
      console.error("Los datos cargados no son un array:", data);
    }

    if (Array.isArray(dataTipArm)) {
      this.tipoarmas = dataTipArm;
    } else {
      console.error("Los datos cargados no son un array:", dataTipArm);
    }

    if (Array.isArray(dataProcedencia)) {
      this.procedencias = dataProcedencia;
    } else {
      console.error("Los datos cargados no son un array:", dataProcedencia);
    }

    if (Array.isArray(dataClasificacionarma)) {
      this.clasificacionarmas = dataClasificacionarma;
    } else {
      console.error(
        "Los datos cargados no son un array:",
        dataClasificacionarma
      );
    }
  },
});
</script>
